<h2 mat-dialog-title>{{ data.workorder ? 'Werkopdracht melden' : 'TVM melden' }}</h2>
<mat-dialog-content>
    <form [formGroup]="reportForm" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col">
                @if (!data.workorder) {
                    <div class="mb-3">
                        <h5>Wat mankeert er aan deze TVM?</h5>
                        <mat-radio-group formControlName="type">
                            <mat-radio-button *ngFor="let optionKey of (typeOptions | keyvalue)" [value]="optionKey.key">
                                {{optionKey.value}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                }

                <mat-form-field appearance="fill">
                    <mat-label>{{ data.workorder ? 'Omschrijving' : 'Opmerking' }}</mat-label>
                    <textarea matInput formControlName="comment" [errorStateMatcher]="showErrorAfterInput"></textarea>
                    <mat-error>Omschrijving is verplicht</mat-error>
                </mat-form-field>
            </div>

            <div class="col">
                @if (data.workorder) {
                    <h5>Werkopdracht {{data.workorder.id_4ps ?? data.workorder.source_no}} - {{data.project?.id_4ps ?? data.project?.name}}</h5>
                    <h4>{{data.project?.name}}</h4>
                    <p class="mb-0">{{data.workorder.planned_startdate | codaltDate : 'EEEE d MMMM yyyy H:mm' : data.workorder.planned_enddate}}</p>
                } @else {
                    <h5>TVM #{{data.ttm.id}} - {{data.project.id_4ps ?? data.project.name}}</h5>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <h4 class="mb-0">{{(data.ttmTypes | byKey : data.ttm.type_key)?.name}}</h4>
                        <mat-chip [style.background-color]="'#' + (data.ttmStatuses | byKey: data.ttm.status_key)?.color">
                            {{(data.ttmStatuses | byKey: data.ttm.status_key)?.name}}
                        </mat-chip>
                    </div>
                    <div *ngFor="let entity of data.ttm.entities" class="mb-3">
                        <div class="d-flex justify-content-between mb-2">
                            <h4>{{entity.handle}}</h4>
                            <h5>{{entity.name}}</h5>
                            <a href="https://maps.google.com/?q={{entity.gnd.coordinates[0][1]}},{{entity.gnd.coordinates[0][0]}}" target="_blank">
                                {{entity.gnd.coordinates[0][1] | number : '0.0-3'}}, {{entity.gnd.coordinates[0][0] | number : '0.0-3'}}
                            </a>
                        </div>
                        <div class="d-flex justify-content-evenly">
                            <div class="ttm-image" app-svg-as-img [svg]="entity?.plain_image?.svg"></div>
                            <div class="ttm-image" app-svg-as-img [svg]="entity?.projected_image?.svg"></div>
                            @if (entity?.gnd_image?.svg) {
                                <div class="ttm-image" app-svg-as-img [svg]="entity?.gnd_image?.svg"></div>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="actions d-flex justify-content-between">
            <button mat-button type="button" (click)="onClose()">Sluiten</button>
            <button mat-raised-button color="primary" type="submit" [disabled]="reportForm.invalid">Melden</button>
        </div>
    </form>
</mat-dialog-content>
